








































import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'

@Component
export default class KoutsuhiCard extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected koutsuhi!: ApiGeneralSinglePayload

  protected get isToday(): boolean {
    const hasseiBiDate = this.du.convertStrToDate(this.koutsuhi.hasseiBi as string)
    return this.du.equalsDate(hasseiBiDate, this.du.now())
  }

  protected get keiroStr(): string {
    const keiroList = this.koutsuhi.keiroList
    if (Array.isArray(keiroList)) {
      return this.tcw.createKoutsuhiKeiroStr(keiroList as ApiGeneralObjectArrayPayload)
    } else {
      return ''
    }
  }

  protected get goukeiKingaku(): string {
    if (typeof this.koutsuhi?.goukeiKingaku === 'number') {
      return this.koutsuhi.goukeiKingaku.toLocaleString()
    } else {
      return ''
    }
  }
  protected openEdit(day: string): void {
    const date = this.tcw.dateOf(day)
    if (date) {
      this.$tcw.$store.basic.setTargetDate(date)
      this.$router.push('/koutsuhi/input/')
    }
  }
}
